import { render, staticRenderFns } from "./Anexar.vue?vue&type=template&id=480cdffa&scoped=true"
import script from "./Anexar.vue?vue&type=script&lang=js"
export * from "./Anexar.vue?vue&type=script&lang=js"
import style0 from "./Anexar.vue?vue&type=style&index=0&id=480cdffa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480cdffa",
  null
  
)

export default component.exports